module.exports = __webpack_public_path__ + "static/logo.dbfe6b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 412
// module chunks = 114276838955818